import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import utc from 'dayjs/plugin/utc';
import { DateFormat } from '../constants/GeneralConstants';
dayjs.extend(utc);
dayjs.extend(duration);
export const formatDate = (date, originalFormat, formatBy = DateFormat.YYYY_MM_DD.value) => {
    const finalDate = replaceAllDashesBySlashes(date);
    switch (originalFormat) {
        case DateFormat.DD_MM_YYYY.value:
            return format(change(finalDate), formatBy);
        default:
            return format(finalDate, formatBy);
    }
};
export const format = (date, formatBy) => {
    const d = new Date(date);
    let month = String(d.getMonth() + 1);
    let day = String(d.getDate());
    const year = d.getFullYear();
    switch (formatBy) {
        case DateFormat.DD_MM_YYYY.value:
            month = (month.length < 2 ? '0' : '') + month;
            day = (day.length < 2 ? '0' : '') + day;
            return [day, month, year].join('-');
        case DateFormat.YYYY_MM_DD.value:
            month = (month.length < 2 ? '0' : '') + month;
            day = (day.length < 2 ? '0' : '') + day;
            return [year, month, day].join('-');
        default:
            return date;
    }
};
export const convertToDayJsDate = (inputValue) => {
    const dayJsInstance = dayjs.extend(customParseFormat);
    if (typeof inputValue === 'string') {
        const possibleDateFormats = ['DD-MM-YYYY', 'YYYY-MM-DD', 'DDMMYYYY'];
        let parsedDate = null;
        possibleDateFormats.forEach(formatDateParser => {
            if (!(!!parsedDate && parsedDate.isValid())) {
                // @ts-expect-error Type 'Dayjs' has no call signatures.
                parsedDate = dayJsInstance(inputValue, formatDateParser);
            }
        });
        return parsedDate;
    }
    return new dayjs.Dayjs(inputValue);
};
export const formatTimeStampToDateString = (timeStamp, locale, format = {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
}) => {
    locale = locale.replace('_', '-');
    if (typeof window !== 'undefined' && window.Intl) {
        return new Intl.DateTimeFormat(locale, format).format(timeStamp);
    }
    else {
        return new Date(timeStamp).toLocaleDateString(locale, format);
    }
};
export const calculateDifferenceInMs = (from, till) => {
    const dateFrom = new Date(from);
    const dateTill = new Date(till);
    return dateFrom.getTime() - dateTill.getTime();
};
export const getDaysInMonth = (year, month) => {
    return new Date(year, month, 0).getDate();
};
export const convertMillisecondsToDays = (milliseconds) => {
    return dayjs.duration(milliseconds).asDays();
};
export const convertMillisecondsToUTCDate = (milliseconds, format) => {
    return dayjs(milliseconds).utc().format(format);
};
export const isToday = (date) => {
    const currentDate = new Date();
    const targetDate = new Date(date);
    return (currentDate.getDate() === targetDate.getDate() &&
        currentDate.getMonth() === targetDate.getMonth() &&
        currentDate.getFullYear() === targetDate.getFullYear());
};
export const isTomorrow = (date) => {
    const tomorrow = dayjs().add(1, 'day');
    return dayjs(date).isSame(tomorrow, 'day');
};
const change = (date) => {
    const dateParts = date.split('/');
    return `${dateParts[1]}/${dateParts[0]}/${dateParts[2]}`;
};
const replaceAllDashesBySlashes = (value) => {
    return value.replace(/-/g, '/');
};
export const formatDateToParts = (date, locale, format) => formatTimeStampToDateParts(new Date(date).getTime(), locale, format);
export const formatTimeStampToDateParts = (timeStamp, locale, format = {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
}) => {
    const date = new Date(timeStamp);
    const formattedDateParts = {};
    locale = locale.replace('_', '-');
    Object.keys(format).forEach(key => {
        formattedDateParts[key] = date.toLocaleDateString(locale, {
            [key]: format[key],
        });
    });
    return formattedDateParts;
};
export const getAllWeekdays = (date, locale, format = {
    weekday: 'long',
}) => {
    const weekdays = [];
    for (let i = 0; i < 7; i++) {
        weekdays.push(new Intl.DateTimeFormat(locale, format).format(date));
        date.setDate(date.getDate() + 1);
    }
    return weekdays;
};
